import React from 'react'
import AboutView from '../views/aboutView'

export default function AboutPresenter() {
  return (
    <AboutView/>
  )
}
